var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-y-6"},_vm._l((_vm.data.fontWeight),function(value,prop){return _c('div',{key:prop},[_c('p',{staticClass:"mb-2 leading-none text-2xl text-gray-900 dark:text-gray-500",style:({
        fontWeight: value
      })},[_vm._v("\n      "+_vm._s(_vm.data.typographyExample)+"\n    ")]),_c('CanvasBlockLabel',{attrs:{"label":("font-" + prop),"value":String(value)}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }